import {
  WSActions,
  WSCard,
  WSDivider,
  WSFlexBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { useHistory } from "react-router-dom";
import { useQueryInternalAccountBalance } from "../../../query/banking/queries/useQueryInternalAccountBalance";
import { PATH_TAXES_SENT_TO_IRS } from "../paths";
import { NextPaymentInfo } from "./NextPaymentInfo";

type Props = {
  internalAccountId?: string;
};

export const CardAvailableBalance: React.FC<Props> = props => {
  const history = useHistory();

  const queryBalance = useQueryInternalAccountBalance(
    props.internalAccountId!,
    {
      enabled: !!props.internalAccountId
    }
  );

  const availableBalance = queryBalance.data?.available || 0;
  const currentBalance = queryBalance.data?.balance || 0;
  const pendingAmounts = queryBalance.data?.hold || 0;

  if (!props.internalAccountId) {
    return (
      <WSCard header="Current balance set aside for taxes">
        <WSList gap="XL">
          <WSText.Heading1 weight="book" color="gray300">
            $--
          </WSText.Heading1>
          <NextPaymentInfo />
        </WSList>
      </WSCard>
    );
  }

  return (
    <WSCard
      header="Current balance set aside for taxes"
      shimmer={queryBalance.isInitialLoading}
    >
      <WSList gap="XL">
        <WSText.Heading1 weight="book" color="gray500">
          {formatMoney(availableBalance, queryBalance.data?.currency || "USD")}
        </WSText.Heading1>

        {pendingAmounts || currentBalance ? (
          <WSFlexBox
            direction="column"
            gap="M"
            alignItems="stretch"
            alignContent="stretch"
          >
            {currentBalance ? (
              <WSFlexBox.CenterY justify="space-between">
                <WSText.ParagraphSm color="gray500">
                  Current balance
                </WSText.ParagraphSm>
                <WSText.ParagraphSm color="gray600">
                  {formatMoney(
                    currentBalance,
                    queryBalance.data?.currency || "USD"
                  )}
                </WSText.ParagraphSm>
              </WSFlexBox.CenterY>
            ) : null}
            {pendingAmounts ? (
              <WSFlexBox.CenterY justify="space-between">
                <WSText.ParagraphSm color="gray500">
                  Pending amounts
                </WSText.ParagraphSm>
                <WSText.ParagraphSm color="gray500">
                  {formatMoney(
                    pendingAmounts,
                    queryBalance.data?.currency || "USD"
                  )}
                </WSText.ParagraphSm>
              </WSFlexBox.CenterY>
            ) : null}
          </WSFlexBox>
        ) : null}

        <WSDivider />

        <WSActions
          alignment="fill"
          buttons={[
            {
              label: "Send tax payment",
              kind: "Secondary",
              onClick: () => {
                history.push(PATH_TAXES_SENT_TO_IRS);
              }
            },
            {
              label: "Transfer",
              kind: "Primary",
              onClick: () => {
                history.push("/member/transfer?balance=taxWithholdings");
              }
            }
          ]}
        />

        <NextPaymentInfo />
      </WSList>
    </WSCard>
  );
};
